



















































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import usersAApi from '@/api/users-a'
import {
    SelectOption,
    UserAContactInfoVisibilityRuleDto,
    UserPhoneJson,
    UserEmailJson, IUserAdminRightsSectionUserModel, IUserAdminRightsSection
} from "@/global";
import * as enums from "@/global-enum";
import Helpers from '../../helpers'
import appUtils from '@/plugins/app-utils'
// @ts-ignore
import debounce from 'debounce';
import {AuthModule} from "@/store/modules/auth";

class ContactInfoVisibilityTypeContext {
    label = "";

    typeKey: string;
    type: number;

    getDisplayName: (() => string) | null = null;
    additionalPhone: UserPhoneJson | null = null;
    additionalEmail: UserEmailJson | null = null;

    constructor(typeKey: string, type: number, getDisplayName: (() => string) | null, additionalPhone: UserPhoneJson | null, additionalEmail: UserEmailJson | null) {
        this.typeKey = typeKey;
        this.type = type;
        this.getDisplayName = getDisplayName;

        if (Helpers.isExists(additionalPhone)) {
            this.additionalPhone = additionalPhone;
        } else if (Helpers.isNotEmpty(additionalEmail)) {
            this.additionalEmail = additionalEmail;
        }

        this.updateLabel();
    }

    updateLabel() {
        switch (this.type) {
            case enums.UserContactInfoVisibilityType_AllContactInfo:
                this.label = "Вся інформація";
                break;
            case enums.UserContactInfoVisibilityType_AllPhones:
                this.label = "Всі телефони";
                break;
            case enums.UserContactInfoVisibilityType_AllEmails:
                this.label = "Всі email";
                break;
            case enums.UserContactInfoVisibilityType_MainPhone:
                if (Helpers.isFunction(this.getDisplayName)) {
                    this.label = `Основний телефон (${this.getDisplayName!()})`;
                } else {
                    throw Error("phone is null");
                }
                break;
            case enums.UserContactInfoVisibilityType_MainEmail:
                if (Helpers.isFunction(this.getDisplayName)) {
                    this.label = `Основна пошта (${this.getDisplayName!()})`;
                } else {
                    throw Error("email is null");
                }
                break;
            case enums.UserContactInfoVisibilityType_AdditionalPhone:
                if (Helpers.isExists(this.additionalPhone)) {
                    this.label = `Телефон ${Helpers.isNotEmpty(this.additionalPhone!.label) ? this.additionalPhone!.label : ""} (${this.additionalPhone!.number})`;
                } else {
                    throw Error("phone is null");
                }
                break;
            case enums.UserContactInfoVisibilityType_AdditionalEmail:
                if (Helpers.isExists(this.additionalEmail)) {
                    this.label = `Пошта (${Helpers.isNotEmpty(this.additionalEmail!.emailAddress) ? this.additionalEmail!.emailAddress : ""})`;
                } else {
                    throw Error("email is null");
                }
                break;
            default:
                throw new Error("type is unknown");
        }
    }
}

@Component({
    components: {
    }
})
export default class UserAdminRightsSection extends Vue implements IUserAdminRightsSection {
    @Prop(Object) user: IUserAdminRightsSectionUserModel | undefined;
    @Prop(Function) showErrorNotification: ((errorMessage?: string) => void) | undefined;

    usersAccessOrganizationIds: number[] = [];

    organizations: SelectOption[] = [];

    allContactInfoVisibilityTypes: ContactInfoVisibilityTypeContext[] = [];
    availableContactInfoVisibilityTypes: ContactInfoVisibilityTypeContext[] = [];

    // computed
    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    get userFullName(): string {
        return appUtils.getUserFullName(this.user, true);
    }

    get isRightsSettingsPanelVisible() {
        return !this.$helpers.isExists(this.user) ||
            !this.$helpers.anyInArray(this.user!.accesses, x => x.type === enums.UserAccessType_SystemAdmin);
    }

    get isUsersAccessRightsVisible() {
        const userInfo = AuthModule.obtainUserInfo();
        return this.$helpers.isExists(userInfo) &&
            this.$helpers.anyInArray(userInfo!.accesses, x => x.type === enums.UserAccessType_SystemAdmin);
    }

    get isUserHasUsersAccess(): boolean {
        return this.$helpers.isExists(this.user) &&
            this.$helpers.anyInArray(this.user!.accesses, x => x.type === enums.UserAccessType_Users);
    }

    get isUserHasKnowledgeBaseAccess(): boolean {
        return this.$helpers.isExists(this.user) &&
            this.$helpers.anyInArray(this.user!.accesses, x => x.type === enums.UserAccessType_KnowledgeBase);
    }

    get visibilityTypesRecalculateWatch() {
        return this.$helpers.isExists(this.user) ? [this.user!.mainPhoneNumber, this.user!.username, this.user!.additionalPhones, this.user!.additionalEmails] : [];
    }

    @Watch("visibilityTypesRecalculateWatch", { deep: true,  })
    onAdditionalPhonesChanged() {
        this.updateContactInfoVisibilityTypesLookup();
    }

    // methods
    validateState(ref: string) {
        return this.$appUtils.vvValidateState(this, ref);
    }

    async afterDataInit() {
        if (!this.$helpers.isExists(this.user))
            throw new Error("user is null");

        // set typeKey
        for (let i = 0; i < this.user!.contactInfoVisibilityRules.length; i++) {
            let rule = this.user!.contactInfoVisibilityRules[i];
            switch (rule.type) {
                case enums.UserContactInfoVisibilityType_AllContactInfo:
                case enums.UserContactInfoVisibilityType_AllPhones:
                case enums.UserContactInfoVisibilityType_AllEmails:
                case enums.UserContactInfoVisibilityType_MainPhone:
                case enums.UserContactInfoVisibilityType_MainEmail:
                    rule.typeKey = rule.type.toString();
                    break;
                case enums.UserContactInfoVisibilityType_AdditionalPhone:
                    rule.typeKey = rule.type.toString() + "-" + rule.additionalPhoneIndex;
                    break;
                case enums.UserContactInfoVisibilityType_AdditionalEmail:
                    rule.typeKey = rule.type.toString() + "-" + rule.additionalEmailIndex;
                    break;
            }
        }

        this.updateContactInfoVisibilityTypesLookup();
        this.initUsersAccessOrganizations();

        this.organizations = appUtils.getAvailableOrganizationOptions(this.user!.availableOrganizations);
    }

    updateContactInfoVisibilityTypesLookup() {
        let thisInst = this;

        this.allContactInfoVisibilityTypes = [];
        this.availableContactInfoVisibilityTypes = [];

        if (!this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules, x => x.type === enums.UserContactInfoVisibilityType_AllContactInfo)) {
            this.availableContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AllContactInfo.toString(),
                enums.UserContactInfoVisibilityType_AllContactInfo, null, null, null));
        }
        this.allContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AllContactInfo.toString(),
            enums.UserContactInfoVisibilityType_AllContactInfo, null, null, null));

        if (!this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules, x => x.type === enums.UserContactInfoVisibilityType_AllPhones)) {
            this.availableContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AllPhones.toString(),
                enums.UserContactInfoVisibilityType_AllPhones, null, null, null));
        }
        this.allContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AllPhones.toString(),
            enums.UserContactInfoVisibilityType_AllPhones, null, null, null));

        if (!this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules, x => x.type === enums.UserContactInfoVisibilityType_AllEmails)) {
            this.availableContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AllEmails.toString(),
                enums.UserContactInfoVisibilityType_AllEmails, null, null, null));
        }
        this.allContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AllEmails.toString(),
            enums.UserContactInfoVisibilityType_AllEmails, null, null, null));

        if (!this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules, x => x.type === enums.UserContactInfoVisibilityType_MainPhone)) {
            if (this.$helpers.isNotEmpty(this.user!.mainPhoneNumber)) {
                this.availableContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_MainPhone.toString(),
                    enums.UserContactInfoVisibilityType_MainPhone, () => thisInst.user!.mainPhoneNumber, null, null));
            }
        }
        this.allContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_MainPhone.toString(),
            enums.UserContactInfoVisibilityType_MainPhone, () => thisInst.user!.mainPhoneNumber, null, null));

        if (!this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules, x => x.type === enums.UserContactInfoVisibilityType_MainEmail)) {
            if (this.$helpers.isNotEmpty(this.user!.username)) {
                this.availableContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_MainEmail.toString(),
                    enums.UserContactInfoVisibilityType_MainEmail, () => thisInst.user!.username, null, null));
            }
        }
        this.allContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_MainEmail.toString(),
            enums.UserContactInfoVisibilityType_MainEmail, () => thisInst.user!.username, null, null));

        if (this.$helpers.isArray(this.user!.additionalPhones)) {
            for (let i = 0; i < this.user!.additionalPhones.length; i++) {
                const additionalPhone = this.user!.additionalPhones[i];

                if (!this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules,
                    x => x.type === enums.UserContactInfoVisibilityType_AdditionalPhone && x.additionalPhoneIndex === i)) {
                    if (this.$helpers.isNotEmpty(additionalPhone.label) && this.$helpers.isNotEmpty(additionalPhone.number)) {
                        this.availableContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AdditionalPhone.toString() + "-" + i,
                            enums.UserContactInfoVisibilityType_AdditionalPhone, null, additionalPhone, null));
                    }
                }
                this.allContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AdditionalPhone.toString() + "-" + i,
                    enums.UserContactInfoVisibilityType_AdditionalPhone, null, additionalPhone, null));
            }
        }

        if (this.$helpers.isArray(this.user!.additionalEmails)) {
            for (let i = 0; i < this.user!.additionalEmails.length; i++) {
                const additionalEmail = this.user!.additionalEmails[i];

                if (!this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules,
                    x => x.type === enums.UserContactInfoVisibilityType_AdditionalEmail && x.additionalEmailIndex === i)) {
                    if (this.$helpers.isNotEmpty(additionalEmail.emailAddress)) {
                        this.availableContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AdditionalEmail.toString() + "-" + i,
                            enums.UserContactInfoVisibilityType_AdditionalEmail, null, null, additionalEmail));
                    }
                }
                this.allContactInfoVisibilityTypes.push(new ContactInfoVisibilityTypeContext(enums.UserContactInfoVisibilityType_AdditionalEmail.toString() + "-" + i,
                    enums.UserContactInfoVisibilityType_AdditionalEmail, null, null, additionalEmail));
            }
        }
    }

    addNewVisibilityRuleContext() {
        if (this.availableContactInfoVisibilityTypes.length === 0) return;

        let firstAvailableContactInfoVisibilityType = this.availableContactInfoVisibilityTypes.splice(0, 1)[0];

        switch (firstAvailableContactInfoVisibilityType.type) {
            case enums.UserContactInfoVisibilityType_AllContactInfo:
                this.user!.contactInfoVisibilityRules.push({
                    id: 0,
                    type: enums.UserContactInfoVisibilityType_AllContactInfo,
                    isAllAllowed: true,
                    additionalPhoneIndex: null,
                    additionalEmailIndex: null,
                    allowedOrganizationIds: [],
                    allowedUserIds: [],
                    allowedOptions: [],
                    searchTerm: "",
                    searchOptions: [],
                    typeKey: enums.UserContactInfoVisibilityType_AllContactInfo.toString()
                });
                break;
            case enums.UserContactInfoVisibilityType_AllPhones:
                this.user!.contactInfoVisibilityRules.push({
                    id: 0,
                    type: enums.UserContactInfoVisibilityType_AllPhones,
                    isAllAllowed: true,
                    additionalPhoneIndex: null,
                    additionalEmailIndex: null,
                    allowedOrganizationIds: [],
                    allowedUserIds: [],
                    allowedOptions: [],
                    searchTerm: "",
                    searchOptions: [],
                    typeKey: enums.UserContactInfoVisibilityType_AllPhones.toString()
                });
                break;
            case enums.UserContactInfoVisibilityType_AllEmails:
                this.user!.contactInfoVisibilityRules.push({
                    id: 0,
                    type: enums.UserContactInfoVisibilityType_AllEmails,
                    isAllAllowed: true,
                    additionalPhoneIndex: null,
                    additionalEmailIndex: null,
                    allowedOrganizationIds: [],
                    allowedUserIds: [],
                    allowedOptions: [],
                    searchTerm: "",
                    searchOptions: [],
                    typeKey: enums.UserContactInfoVisibilityType_AllEmails.toString()
                });
                break;
            case enums.UserContactInfoVisibilityType_MainPhone:
                this.user!.contactInfoVisibilityRules.push({
                    id: 0,
                    type: enums.UserContactInfoVisibilityType_MainPhone,
                    isAllAllowed: true,
                    additionalPhoneIndex: null,
                    additionalEmailIndex: null,
                    allowedOrganizationIds: [],
                    allowedUserIds: [],
                    allowedOptions: [],
                    searchTerm: "",
                    searchOptions: [],
                    typeKey: enums.UserContactInfoVisibilityType_MainPhone.toString()
                });
                break;
            case enums.UserContactInfoVisibilityType_MainEmail:
                this.user!.contactInfoVisibilityRules.push({
                    id: 0,
                    type: enums.UserContactInfoVisibilityType_MainEmail,
                    isAllAllowed: true,
                    additionalPhoneIndex: null,
                    additionalEmailIndex: null,
                    allowedOrganizationIds: [],
                    allowedUserIds: [],
                    allowedOptions: [],
                    searchTerm: "",
                    searchOptions: [],
                    typeKey: enums.UserContactInfoVisibilityType_MainEmail.toString()
                });
                break;
            case enums.UserContactInfoVisibilityType_AdditionalPhone:
                for (let i = 0; i < this.user!.additionalPhones.length; i++) {
                    const additionalPhone = this.user!.additionalPhones[i];

                    if (this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules,
                        x => x.type === enums.UserContactInfoVisibilityType_AdditionalPhone && x.additionalPhoneIndex === i)) {
                        this.user!.contactInfoVisibilityRules.push({
                            id: 0,
                            type: enums.UserContactInfoVisibilityType_AdditionalPhone,
                            isAllAllowed: true,
                            additionalPhoneIndex: i,
                            additionalEmailIndex: null,
                            allowedOrganizationIds: [],
                            allowedUserIds: [],
                            allowedOptions: [],
                            searchTerm: "",
                            searchOptions: [],
                            typeKey: enums.UserContactInfoVisibilityType_AdditionalPhone.toString() + "-" + i
                        });
                    }
                }
                break;
            case enums.UserContactInfoVisibilityType_AdditionalEmail:
                for (let i = 0; i < this.user!.additionalEmails.length; i++) {
                    const additionalEmail = this.user!.additionalEmails[i];

                    if (this.$helpers.anyInArray(this.user!.contactInfoVisibilityRules,
                        x => x.type === enums.UserContactInfoVisibilityType_AdditionalEmail && x.additionalEmailIndex === i)) {
                        this.user!.contactInfoVisibilityRules.push({
                            id: 0,
                            type: enums.UserContactInfoVisibilityType_AdditionalEmail,
                            isAllAllowed: true,
                            additionalPhoneIndex: null,
                            additionalEmailIndex: i,
                            allowedOrganizationIds: [],
                            allowedUserIds: [],
                            allowedOptions: [],
                            searchTerm: "",
                            searchOptions: [],
                            typeKey: enums.UserContactInfoVisibilityType_AdditionalEmail.toString() + "-" + i
                        });
                    }
                }
            default:
                throw new Error("type is unknown");
        }

        this.updateContactInfoVisibilityTypesLookup();
    }

    onContactInfoVisibilityRulesChanged(rule: UserAContactInfoVisibilityRuleDto) {
        let parts = rule.typeKey.split("-");
        rule.type = this.$helpers.toNumeric(parts[0]);

        switch (rule.type) {
            case enums.UserContactInfoVisibilityType_AdditionalPhone:
                rule.additionalPhoneIndex = this.$helpers.toNumeric(parts[1]);
                break;
            case enums.UserContactInfoVisibilityType_AdditionalEmail:
                rule.additionalEmailIndex = this.$helpers.toNumeric(parts[1]);
                break;
        }
    }

    searchVisibilityRuleOptions(searchTerm: string, loadingCb: (isLoading: boolean) => void, rule: UserAContactInfoVisibilityRuleDto) {
        rule.searchTerm = searchTerm;

        if (!Helpers.isNotEmpty(rule.searchTerm) || rule.searchTerm.length < this.$const.selectSearchTermMinLength) {
            rule.searchOptions = [];
        } else {
            loadingCb(true);
            this.searchVisibilityRuleOptionsWithTimer(loadingCb, rule);
        }
    }

    searchVisibilityRuleOptionsWithTimer = debounce((loadingCb: (isLoading: boolean) => void, rule: UserAContactInfoVisibilityRuleDto) => {
        usersAApi.adminVisibilityRuleOptions(rule.searchTerm, options => {
            rule.searchOptions = options;

            loadingCb(false);
        }, errorMessage => {
            if (this.$helpers.isFunction(this.showErrorNotification)) {
                this.showErrorNotification!(errorMessage);
            }
            loadingCb(false);
        })
    }, 750);

    initUsersAccessOrganizations() {
        let usersAccess = this.$helpers.findFirstInArray(this.user!.accesses, x => x.type === enums.UserAccessType_Users);

        if (this.$helpers.isExists(usersAccess)) {
            this.usersAccessOrganizationIds = usersAccess!.organizationIds;
        }
    }

    onUsersAccessOrganizationIdsChanged(val: number[]) {
        if (this.$helpers.isExists(this.user)) {
            let usersAccess = this.$helpers.findFirstInArray(this.user!.accesses, x => x.type === enums.UserAccessType_Users);

            if (this.$helpers.isExists(usersAccess)) {
                usersAccess!.organizationIds = val;
            }
        }
    }

    toggleUsersAccess() {
        if (this.$helpers.isExists(this.user)) {
            if (this.isUserHasUsersAccess) {
                this.$helpers.removeInArray(this.user!.accesses, x => x.type === enums.UserAccessType_Users);
            } else {
                this.user!.accesses.push({
                    type: enums.UserAccessType_Users,
                    organizationIds: []
                });
            }
        }
    }

    toggleKnowledgeBaseAccess() {
        if (this.$helpers.isExists(this.user)) {
            if (this.isUserHasKnowledgeBaseAccess) {
                this.$helpers.removeInArray(this.user!.accesses, x => x.type === enums.UserAccessType_KnowledgeBase);
            } else {
                this.user!.accesses.push({
                    type: enums.UserAccessType_KnowledgeBase,
                    organizationIds: []
                });
            }
        }
    }

    validateAll() {
        return this.$validator.validateAll();
    }
}
